import React from 'react';
import { ReactComponent as ArrowDownRed } from 'style/_assets/icons/arrow-down-red.svg';
import { ReactComponent as ArrowDownGreen } from 'style/_assets/icons/arrow-down-green.svg';
import { ReactComponent as ArrowUpGreen } from 'style/_assets/icons/arrow-up-green.svg';
import { ReactComponent as ArrowUpRed } from 'style/_assets/icons/arrow-up-red.svg';
import { ReactComponent as NoChange } from 'style/_assets/icons/minus-2.svg';

const FinalArrow = ({ difference, isPositive, showNochangeIcon }) => {
  let finalArrow = '';

  if (difference === 0.0) {
    finalArrow = showNochangeIcon ? (
      <NoChange
        role="img"
        style={{
          width: '1.25em',
          position: 'relative',
          bottom: '.25em',
        }}
        aria-label={'NoChange'}
      />
    ) : (
      ''
    );
  } else {
    if (difference > 0) {
      if (isPositive)
        finalArrow = (
          <ArrowUpGreen
            role="img"
            style={{
              display: 'block',
              width: '1.25em',
              position: 'relative',
              top: '.25em',
            }}
            aria-label={'ArrowUpGreen'}
          />
        );
      else
        finalArrow = (
          <ArrowUpRed
            role="img"
            style={{
              display: 'block',
              width: '1.25em',
              position: 'relative',
              top: '.25em',
            }}
            aria-label={'ArrowUpRed'}
          />
        );
    } else {
      if (isPositive)
        finalArrow = (
          <ArrowDownGreen
            role="img"
            style={{
              display: 'block',
              width: '1.25em',
              position: 'relative',
              top: '.25em',
            }}
            aria-label={'ArrowDownGreen'}
          />
        );
      else
        finalArrow = (
          <ArrowDownRed
            role="img"
            style={{
              display: 'block',
              width: '1.25em',
              position: 'relative',
              top: '.25em',
            }}
            aria-label={'ArrowDownRed'}
          />
        );
    }
  }
  return (
    <div className="inblock" style={{ marginRight: '.25em' }}>
      {finalArrow}
    </div>
  );
};

export default FinalArrow;
